import { createApp } from 'vue'
import App from './App.vue'
import 'lib-flexible'
import vConsole from 'vconsole'
import { createRouter, createWebHistory } from 'vue-router'

const isEnvProduction = process.env.NODE_ENV === 'production'

if (!isEnvProduction) {
  new vConsole()
}

const routes = [
  {
    path: '/verifyMetaData/:photoCode/:textType',
    name: 'VerifyMetaData',
    component: App
  },
  {
    path: '/s/:photoCode/:textType',
    name: 'VerifyMetaData2',
    component: App
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

const app = createApp(App)
app.use(router)

app.mount('#app')
